import Axios from 'axios'
import { conservationFeesUrls } from '../urls'
import router from '../../../router'

export default {
  get_all_conservation_fees (context) {
    Axios.get(conservationFeesUrls.getAllConservationFees).then(function (response) {
      context.commit('GET_ALL_CONSERVATION_FEES', response.data)
    })
  },
  get_conservation_fee_by_check_in_date (context, data) {
    Axios.post(conservationFeesUrls.getPublicConservationFeeByCheckIn, data).then(function (response) {
      context.commit('GET_ALL_CONSERVATION_FEES', response.data)
    })
  },
  get_conservation_fee_by_check_in_out_date (context, data) {
    Axios.post(conservationFeesUrls.getPublicConservationFeeByCheckInOut, data).then(function (response) {
      context.commit('GET_ALL_CONSERVATION_FEES', response.data)
    })
  },
  get_newly_scheduled_pricing (context, data) {
    Axios.post(conservationFeesUrls.getAllScheduledConservationFees, data).then(function (response) {
      context.commit('GET_ALL_CONSERVATION_FEES', response.data)
    })
  },
  get_newly_scheduled_school_pricing (context, data) {
    Axios.post(conservationFeesUrls.getAllScheduledSchoolConservationFees, data).then(function (response) {
      context.commit('GET_ALL_SCHOOL_CONSERVATION_FEES', response.data)
    })
  },
  get_full_conservation_fees (context) {
    Axios.get(conservationFeesUrls.getFullConservationFees).then(function (response) {
      context.commit('GET_FULL_CONSERVATION_FEES', response.data)
    }).catch(function (error) {})
  },

  get_all_conservation_schedule (context) {
    Axios.get(conservationFeesUrls.getFullConservationSchedule).then(function (response) {
      context.commit('GET_FULL_CONSERVATION_SCHEDULE', response.data)
    })
  },

  get_all_bnl_schedules (context) {
    Axios.get(conservationFeesUrls.getBnlSchedules).then(function (response) {
      context.commit('GET_ALL_BNL_SCHEDULES', response.data)
    })
  },
  post_bnl_schedule (context, payload) {
    return Axios.post(conservationFeesUrls.postBnlSchedule, payload).then(function (response) {
      context.dispatch('get_all_bnl_schedules');
      return response;
    })
  },
  disable_bnl_schedule (context, payload) {
    return Axios.patch(conservationFeesUrls.disableBnlSchedule, payload).then(function (response) {
      context.dispatch('get_all_bnl_schedules');
      return response;
    })
  },
  post_bnl_price (context, payload) {
    return Axios.post(conservationFeesUrls.postBnlPrice, payload).then(function (response) {
      context.dispatch('get_all_bnl_schedules');
      return response;
    })
  },

  all_school_conservation_fees (context) {
    Axios.get(conservationFeesUrls.getSchoolConservationFees).then(function (response) {
      context.commit('GET_ALL_SCHOOL_CONSERVATION_FEES', response.data)
    })
  },
  get_conservation_fees (context, publicId) {
    Axios.get(conservationFeesUrls.getConservationFees + publicId).then(function (response) {
      context.commit('GET_CONSERVATION_FEES', response.data)
    })
  },
  get_deleted_conservation_fees (context) {
    Axios.get(conservationFeesUrls.getDeletedConservationFee).then(function (response) {
      context.commit('GET_DELETED_CONSERVATION_FEES', response.data)
    })
  },
  get_conservation_fee (context, publicId) {
    Axios.get(conservationFeesUrls.getConservationFee + publicId).then(function (response) {
      context.commit('GET_CONSERVATION_FEE', response.data)
    })
  },
  post_conservation_fee (context, data) {
    Axios.post(conservationFeesUrls.postConservationFee, data).then(function () {
      context.dispatch('get_full_conservation_fees')
    }).catch(function (error) {
      console.log(error.data)
    })
  },
  post_conservation_fee_schedule (context, data) {
    Axios.post(conservationFeesUrls.postConservationFeeSchedule, data).then(function () {
      context.dispatch('get_full_conservation_fees')
    }).catch(function (error) {
      console.log(error.data)
    })
  },
  update_conservation_fee (context, data) {
    Axios.patch(conservationFeesUrls.editConservationFee, data).then(function () {
      context.dispatch('get_full_conservation_fees')
    }).catch(function (error) {
      console.log(error.data)
    })
  },
  delete_conservation_fee (context, data) {
    Axios.patch(conservationFeesUrls.deleteConservationFee, data).then(function () {
      context.dispatch('get_all_conservation_schedule')
    })
  },
  edit_conservation_schedule (context, data) {
    Axios.patch(conservationFeesUrls.ModifyConservationSchedule, data).then(function () {
      context.dispatch('get_all_conservation_schedule')
    })
  },
  edit_conservation_schedule_pricing (context, data) {
    Axios.patch(conservationFeesUrls.ModifyConservationSchedulePricing, data).then(function () {
      context.dispatch('get_all_conservation_schedule')
    })
  },
  delete_conservation_schedule (context, data) {
    Axios.patch(conservationFeesUrls.DeleteConservationSchedule, data).then(function () {
      context.dispatch('get_all_conservation_schedule')
    })
  },
  restoreConservationFee (context, publicId) {
    Axios.get(conservationFeesUrls.restoreConservationFee + publicId).then(function (response) {
      alert(response.data.message)
      context.commit('GET_ALL_CONSERVATION_FEES', response.data)
      router.push({
        name: 'Module.ConservationFees'
      })
    })
  },
  get_proof_of_residence (context, data) {
    Axios.post(conservationFeesUrls.getProofOfResidency, data).then(function (response) {
      context.commit('PROOF_RESIDENCY_BOOKING_ID', response.data)
    })
  },
  delete_proof_residency (context, data) {
    Axios.patch(conservationFeesUrls.DeleteProofResidency, data).then(function () {
      context.dispatch("get_booking", data.residency_booking_id);
    })
  },
}